var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"hidden-sm-and-down",attrs:{"divider":"/"}},_vm._l((_vm.breadcrumbList),function(breadcrumb,idx){return _c('v-breadcrumbs-item',{key:idx,attrs:{"disabled":!!!breadcrumb.route,"exact":""},nativeOn:{"click":function($event){return _vm.routeTo(idx)}}},[_vm._v(" "+_vm._s(_vm.nameOf(idx))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }